module.exports = __webpack_public_path__ + "img/4-5.4f203f17.svg";